module.exports = __webpack_public_path__ + "img/sn_2.bedd0b05.jpg";